<template>
    <VJoyDialog
        id="project-candidate-delete-dialog"
        size="large"
        :open="isConfirmDeleteDialogOpen"
        :confirm-text="$t('general.validate')"
        :cancel-text="$t('general.cancel')"
        @dialog:confirm="emits('delete')"
        @dialog:hide="isConfirmDeleteDialogOpen = false"
    >
        <template #dialog-header>
            {{ $t('profile.vetting.drawer.tab.profile.notes.actions.delete.confirm.label') }}
        </template>
    </VJoyDialog>

    <VJoyDropdown :options="options" size="medium" direction="down" justify="right" width="150">
        <template #dropdown-button>
            <button type="button" class="dropdown-button" :aria-label="$t('profile.vetting.drawer.tab.profile.notes.option.label')">
                <VJoyIcon name="dots-vertical" size="xsmall" />
            </button>
        </template>
        <template #dropdown-item="option">
            <span @click="option.action">{{ option.label }}</span>
        </template>
    </VJoyDropdown>
</template>

<script setup lang="ts">
    import {computed, ref} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyDialog, VJoyDropdown, VJoyIcon} from '@maltjoy/core-vue';

    interface Option {
        action: () => void;
        id: string;
        label: string;
    }

    const emits = defineEmits<{
        (e: 'edit'): void;
        (e: 'delete'): void;
    }>();

    const {t} = useTranslation();
    const isConfirmDeleteDialogOpen = ref(false);

    const options = computed((): Option[] => {
        const actions = [];
        actions.push({
            label: t('profile.vetting.drawer.tab.profile.notes.tools.delete'),
            id: 'profile-notes-action-delete',
            action: () => {
                isConfirmDeleteDialogOpen.value = true;
            },
        });

        actions.push({
            label: t('profile.vetting.drawer.tab.profile.notes.tools.edit'),
            id: 'profile-notes-action-edit',
            action: () => {
                emits('edit');
            },
        });

        return actions;
    });
</script>
